<template>
  <div class="row mb-3 header-edit">
    <div class="col-12 col-lg-11 col-xl-11 col-md-11 pr-0 heavy-items-wrapper">
      <div
        class="heavy-items-orange position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
      >
        <div class="col-5 flex">
          <span class="mod-icon-weight d-inline-block mr-3" />
          <p>Are there heavy items for this move?</p>
        </div>
        <div class="col-3">
          <p @click="editable && toggleHasHeavyItems()">
            <span>No</span>
            <label class="switch" @click.prevent>
              <input type="checkbox" :checked="data.has_heavy_items" />
              <span class="check-slider round" :class="editable ? '' : 'disabled'" />
            </label>
            <span :class="data.has_heavy_items ? 'yes-active' : ''">Yes</span>
          </p>
        </div>
        <div class="col-4 inputs">
          <div class="row" v-show="data.has_heavy_items">
            <div class="col-6">
              <div
                class="select-wrap amount-wrap"
                :class="modelHeavyItemsFee && !editing ? 'border-0' : ''"
              >
                <label>Heavy items fee</label>
                <span class="dollar">$</span>
                <input
                  v-model="heavyItemsFee"
                  type="text"
                  class="form-control"
                  :disabled="(modelHeavyItemsFee && !editing) || !editable"
                />
              </div>
            </div>
            <div class="col-6">
              <button
                v-if="modelHeavyItemsFee && !editing"
                type="button"
                class="btn btn-primary"
                @click="editing = true"
                :disabled="!editable"
              >
                Edit
              </button>
              <button
                v-else
                type="button"
                class="btn btn-primary"
                @click="saveHeavyItemsFee"
                :disabled="!editable"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';

export default {
  name: 'HeavyItemsDisclaimer',
  props: {
    companyHeavyItemsFee: {
      type: String,
      default: '0.00',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    hasHeavyItems: {
      type: Boolean,
      default: false,
    },
    jobId: {
      type: Number,
      default: null,
    },
    leadId: {
      type: Number,
      default: null,
    },
    modelHeavyItemsFee: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: {
        has_heavy_items: this.hasHeavyItems,
        heavy_items_fee: this.companyHeavyItemsFee,
      },
      editing: false,
    };
  },
  computed: {
    heavyItemsFee: {
      get() {
        return this.modelHeavyItemsFee ? this.modelHeavyItemsFee : this.companyHeavyItemsFee;
      },
      set(newValue) {
        this.data.heavy_items_fee = newValue;
        return newValue;
      },
    },
  },
  methods: {
    saveHeavyItemsFee() {
      this.editing = false;
      const url = this.jobId
        ? `/jobs/${this.jobId}/heavy-items`
        : `/leads/${this.leadId}/heavy-items`;
      axios
        .patch(url, this.data)
        .then(() => {
          this.$emit(this.jobId ? 'getJob' : 'getLead');
          toastr.success('Heavy items fee updated successfully');
        })
        .catch(() => {
          this.editing = true;
          toastr.error('Failed to update heavy items fee');
        });
    },
    toggleHasHeavyItems() {
      this.data.has_heavy_items = !this.data.has_heavy_items;
      if (!this.data.has_heavy_items) {
        this.saveHeavyItemsFee();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.heavy-items-orange {
  background-color: #fffcf4;
  border: solid 1px #ffab00;
  border-radius: 4px;
  margin-left: 30px;
  min-height: 74px;
  display: flex;
  align-items: center;
  padding: 14px 0;
  width: 95%;

  p {
    display: flex;
    align-items: center;

    .switch {
      margin-left: 16px;
    }

    .yes-active {
      color: #2962ff;
    }
  }
  .inputs {
    transition: all 0.4s ease-in-out;
  }
  .select-wrap {
    min-height: 42px;
  }
  .amount-wrap span {
    top: 20px;
  }
  .select-wrap .form-control {
    height: 42px;
  }
  .select-wrap .form-control:disabled {
    opacity: initial;
  }
  .btn-primary {
    width: inherit;
  }
}
@media (max-width: 1820px) {
  .header-edit .heavy-items-orange {
    width: 94%;
  }
}

@media (max-width: 1700px) {
  .header-edit .heavy-items-orange {
    width: 93%;
  }
}

@media (max-width: 1600px) {
  .header-edit .heavy-items-orange {
    width: 91%;
  }
}

@media (max-width: 1450px) {
  .header-edit .heavy-items-orange {
    width: 90%;
  }
}

@media (max-width: 1360px) {
  .header-edit .heavy-items-orange {
    width: 88%;
  }
}
@media (max-width: 450px) {
  .header-edit .heavy-items-orange {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeavyItemsDisclaimer.vue